import { render, staticRenderFns } from "./NewsLatterEmails.vue?vue&type=template&id=918832ea&scoped=true"
import script from "./NewsLatterEmails.vue?vue&type=script&lang=js"
export * from "./NewsLatterEmails.vue?vue&type=script&lang=js"
import style0 from "./NewsLatterEmails.vue?vue&type=style&index=0&id=918832ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918832ea",
  null
  
)

export default component.exports